import React from 'react'
import styles from './StatusHandler.module.scss'
import { LabeledStatusToggleButton } from 'components'
import { StatusHandlerProps } from './types'
import { AgreementStatusTypes } from 'models'

const StatusHandler = (props: StatusHandlerProps) => {
  const { agreement } = props

  const handleOnClick = () => {
    // const newStatus = project.status === statusOptions.PUBLISHED
    //   ? statusOptions.NOT_PUBLISHED
    //   : statusOptions.PUBLISHED;

    // changeStatus(project.id, newStatus);
  }

  return (
    <div className={styles.container}>
      <LabeledStatusToggleButton
        status={agreement.status}
        onClick={handleOnClick}
        switchedOn={agreement.status === AgreementStatusTypes.ACTIVE}
        className={styles.labeledStatusToggleBttn}
      />
    </div>
  )
}

export default StatusHandler
